import { useMemo } from 'react';
import { LocalStorage } from 'enums';
import { useLocalStorage, useSearchMarket } from 'hooks';

export default function useSelectedMarket() {
  const { items: eligibleMarkets, isLoading: isLoadingMarkets } = useSearchMarket();
  const [selectedMarketId] = useLocalStorage<string | null>(LocalStorage.OpExSelectedMarketId, null);

  const selectedMarket = useMemo(
    () => (selectedMarketId ? eligibleMarkets.find((m) => m.id === selectedMarketId) ?? null : null),
    [eligibleMarkets, selectedMarketId],
  );

  return { selectedMarket, selectedMarketId, isLoadingMarkets };
}
